// Eigene Stimmen von Kundinnen, Kunden und Angehörigen für die Startseite.
// Werden nur genutzt, wenn keine Google-Rezensionen geladen werden können
// (Cloud Function "googleReviews", siehe functions-reviews/index.js).
// Nur echte Rückmeldungen eintragen, und nur mit Einverständnis der Person.
// Den Namen am besten abkürzen (z. B. "Sabine K."), dazu die Beziehung
// zur versorgten Person und den Ort.
//
// Solange die Liste leer ist, wird die Sektion auf der Live-Seite nicht
// angezeigt. Im Entwicklungsmodus erscheinen markierte Platzhalter, damit
// man das Layout beurteilen kann.
//
// Beispiel:
//   {
//     quote: 'Seit Cura Care meine Mutter morgens und abends versorgt, ...',
//     name: 'Sabine K.',
//     context: 'Tochter einer Kundin, Eitorf'
//   }
const reviews = [];

/* TODO: Link zum Google-Unternehmensprofil eintragen (Bewertungen ansehen).
   Leer = der Link wird nicht angezeigt. */
export const googleReviewsUrl = '';

export default reviews;
